<template>
  <ComboPicker
    :label="orientation == 'horizontal' ? null : label"
    strings="objeto;o"
    icon="mdi-cube-outline"
    :bothIcons="orientation == 'horizontal'"
    :value="value"
    @input="(v) => $emit('input', v)"
    :whenEmpty="orientation == 'horizontal' ? 'Todos os objetos' : '(Todos)'"
    types="grouped-items"
    :tags="[]"
    :items="allItems"
  />
</template>

<script>
import ComboPicker from 'oderon-vue/cpts/pickers/ComboPicker'

export default {
  components: {
    ComboPicker
  },
  props: {
    label: { type: String, default: 'Ação no Objeto' },
    orientation: { type: String, default: 'horizontal' },
    value: {}
  },
  mounted() {
    this.fetchData()
  },
  data() {
    return {
      allItems: []
    }
  },
  methods: {
    async fetchData() {
      let rows = [
        { name: 'Motorista', id: 'driver' },
        { name: 'Inteligência Embarcada', id: 'ei' },
        { name: 'Ocorrência', id: 'occurConfig' },
        { name: 'Polígono', id: 'polygon' },
        { name: 'Veículo', id: 'vehicle' }
      ]

      this.allItems = rows
    }
  }
}
</script>

<style></style>
